export const getIssueRemedialActionComments = (issue) => {
  let com = "";
  com =
    issue.remedialAction && issue.remedialActionItems && issue.remedialActionItems.length > 0 && issue.remedialActionItems[0].value
      ? issue.remedialActionItems[0].value
      : "";
  let slowOrderRestrict =
    issue.remedialActionItems &&
    issue.remedialActionItems.length > 0 &&
    issue.remedialActionItems.find((item) => item.id === "slowOrderSpeedRestict");

  if (issue.remedialAction === "Slow Order Applied" && slowOrderRestrict) {
    let slowOrderComment =
      issue.remedialActionItems && issue.remedialActionItems.length > 0 && issue.remedialActionItems.find((item) => item.id === "describe");
    com += " Reduced to " + slowOrderRestrict.value;
    com += slowOrderComment && slowOrderComment.value ? " - " + slowOrderComment.value : "";
  }
  return com;
};

const SeptaClassesLookup = {
  "Class #4": "R4",
  "Class #3": "R3",
  "Class #2": "R2",
  "Class #1": "R1",
};

export const getIssueRemedialActionSlashCommentsForSepta = (issue) => {
  let com = "";
  com = issue.remedialAction && issue.remedialActionItems && issue.remedialActionItems.length > 0 ? issue.remedialActionItems[0].value : "";
  let slowOrderRestrict =
    issue.remedialActionItems &&
    issue.remedialActionItems.length > 0 &&
    issue.remedialActionItems.find((item) => item.id === "slowOrderSpeedRestict");

  let remedialAction = issue.remedialAction;
  if (issue.remedialAction === "Slow Order Applied" && slowOrderRestrict) {
    if (Object.keys(SeptaClassesLookup).includes(slowOrderRestrict.value)) {
      remedialAction = SeptaClassesLookup[slowOrderRestrict.value];
    }
    let slowOrderComment =
      issue.remedialActionItems && issue.remedialActionItems.length > 0 && issue.remedialActionItems.find((item) => item.id === "describe");
    com += " Restricted to " + slowOrderRestrict.value;
    com += slowOrderComment && slowOrderComment.value ? " - " + slowOrderComment.value : "";
  }

  return [remedialAction, com]
    .map((v) => v)
    .map((val) => val.trim())
    .filter((v) => v !== "")
    .join(" / ");
};



// WEBPACK FOOTER //
// ./src/components/Reports/utils/getIssueRemedialActionComments.js